module.exports = __webpack_public_path__ + "media/images/menu_arrow-15d071a5684f545e10901230ba8a5493.png";